// extracted by mini-css-extract-plugin
export default {"msg":"Notify_msg__wm6MW","error":"Notify_error__YiHII","warn":"Notify_warn__n7W4I","info":"Notify_info__RE6Y4"};